<template>
  <div class="section section__lk">
    <div class="section__wrapper section__subsection-wrapper">
      <div class="d-flex justify-content-between">
        <div class="title-with-icon mb-48">
          <div class="title-with-icon__icon title-with-icon__icon_order"></div>
          <div class="title-with-icon__title">
            <span v-if="program">Заявка на программу: &laquo;{{ program.title }}&raquo;</span>
            <span v-else>Заявка на онлайн программу</span>
          </div>
        </div>
      </div>
      <div class="section__lk-wrapper">
        <div class="section__lk-order-info container-shadow fill-white mr-24 p-24 d-none d-md-block">
          <div class="section__lk-order-info__security">
            <template v-if="isHitech">
              <p>
                Заполнение полей необходимо для оформления заявки на обучение по программе повышения квалификации.
                После отправки заявки Ваши данные проверит администратор: заявка будет одобрена
                или отправлена на доработку с комментарием.
                Школа экспорта обеспечивает конфиденциальность персональных данных заявителя.</p>
              <ul>
                <li>для заявки понадобятся сканы паспорта, СНИЛС, диплома и направление на обучение от работодателя по шаблону</li>
                <li>после одобрения заявки в личном кабинете откроются модули контактного этапа</li>
                <li>итоговое тестирование проходит в личном кабинете после контактного этапа</li>
              </ul>
            </template>
            <template v-else>
              <p>
                Заполнение полей необходимо для оформления заявки на дистанционное обучение.
                После заполнения полей Ваши данные отправятся на проверку администраторам для одобрения Вашего участия.
                Школа экспорта обеспечивает конфиденциальность персональных данных заявителя.</p>
              <ul>
                <li>возможность бесплатно пройти обучение по всем курсам Школы Экспорта РЭЦ</li>
                <li>доступ ко всем обучающим материалам в течение года с момента одобрения заявки</li>
              </ul>
            </template>
          </div>
        </div>
        <!-- форму HITECH показываем только после сверки ID программы с бэкендом: форма при открытии создаёт черновик заявки -->
        <online-order-form v-if="!isHitech || formReady" :has-full="true" :hide-organization="true" :hide-direction-scan="!isHitech" :program-id="programId" />
      </div>
      <div class="section__lk-order-info__security d-block d-md-none container-shadow fill-white mt-24 p-24">
        <template v-if="isHitech">
          <p><a href="#" class="content_red">Заполнение полей</a> необходимо для проверки Ваших данных
            администраторами<sup>1</sup> для одобрения Вашего
            участия. Школа экспорта обеспечивает конфиденциальность персональных данных заявителя.</p>
          <p>После отправки заявка будет одобрена или отправлена на доработку с комментарием администратора.</p>
          <ul>
            <li>для заявки понадобятся сканы паспорта, СНИЛС, диплома и направление на обучение от работодателя по шаблону</li>
            <li>после одобрения заявки в личном кабинете откроются модули контактного этапа</li>
            <li>итоговое тестирование проходит в личном кабинете после контактного этапа</li>
          </ul>
        </template>
        <template v-else>
          <p><a href="#" class="content_red">Заполнение полей</a> необходимо для проверки Ваших данных
            администраторами<sup>1</sup> для одобрения Вашего
            участия. Школа экспорта обеспечивает конфиденциальность персональных данных заявителя.</p>
          <p>Заключение договора откроет для вас следующие возможности:</p>
          <ul>
            <li>возможность бесплатно пройти обучение по всем курсам Образовательной программы РЭЦ</li>
            <li>возможность получить удостоверение о повышении квалификации по программе «Старт экспортной деятельности: 10 шагов к успеху»</li>
            <li>доступ ко всем обучающим материалам в течение года с момента заключения договора на обучение</li>
          </ul>
        </template>
        <p class="section__lk-order-info__notice content_14"><sup>1</sup> Приказ Министерства образования и науки
          Российской Федерации от
          01.07.2013 №499 "Об утверждении Порядка организации и осуществления образовательной деятельности по
          дополнительным профессиональным программам".</p>
      </div>
    </div>
  </div>
</template>

<script>
import OnlineOrderForm from "@/components/OnlineOrderForm.vue";
import ApiService from "../../services/api.service";
import {isHitechProgram} from "@/data/programs";

export default {
  name: "ProgramOrder",
  components: {OnlineOrderForm},
  data() {
    return {
      program: null,
      programId: this.$route.params.id ? parseInt(this.$route.params.id) : null,
      // все проверки программы пройдены (для HITECH — и сверка с бэкендом)
      formReady: false
    }
  },
  computed: {
    isStudent() {
      return this.programId == 56
    },
    isTeacher() {
      return this.programId == 57
    },
    // Программа ПК «Экспорт высокотехнологичной продукции»
    isHitech() {
      return isHitechProgram(this.programId)
    }
  },
  async mounted() {
    this.$parent.init()
    if(this.programId) {
      if(!this.isStudent && !this.isTeacher && !this.isHitech) {
        await this.$router.push('/education#online')
        return
      }

      // HITECH включается отдельно на фронте (VUE_APP_HITECH_PROGRAM_ID) и на бэкенде (hitech_program_id).
      // Если на бэкенде он не включён, заявка ушла бы по общей ветке онлайн-программ (письма, сертификаты, админка),
      // поэтому форму не открываем
      if(this.isHitech) {
        let res
        try {
          res = await ApiService.get('programparticipant/hitech')
        } catch (error) {
          console.error('Ошибка проверки программы HITECH:', error)
          this.$toastr.e('', 'Не удалось открыть форму заявки. Обновите страницу')
          return
        }
        // Проверка не прошла: форму не открываем. На 401/403 глобальный обработчик ApiService
        // сам ведёт на вход и вернёт на форму после авторизации — не перебиваем его своим редиректом
        if(!res || res.status >= 300) {
          if(!res || (res.status !== 401 && res.status !== 403)) {
            this.$toastr.e('', 'Не удалось открыть форму заявки. Обновите страницу')
          }
          return
        }
        const backendHitechId = Number(res.data && res.data.hitech_program_id) || 0
        if(backendHitechId !== this.programId) {
          console.error(`VUE_APP_HITECH_PROGRAM_ID=${this.programId}, а hitech_program_id на бэкенде: ${backendHitechId || 'не задан'}`)
          await this.$router.push('/education#online')
          return
        }
      }

      try {
        const response = await ApiService.get(`programs/${this.programId}`)
        this.program = response.data
        
        // Если тип программы не 'online', редиректим на /education#online
        if(this.program && this.program.type !== 'online') {
          await this.$router.push('/education#online')
          return
        }
      } catch (error) {
        console.error('Ошибка загрузки программы:', error)
      }
    }
    this.formReady = true
  }
}
</script>

<style scoped lang="scss">
.section__lk-order-info {
  max-width: 30%;
}
.section__lk-order-info__security {
  font-size: 1.8rem;
  line-height: 3.2rem;
  p, ul li {
    line-height: 3.2rem;
  }
  li::marker {
    font-size: .5em;
  }
  @media (max-width: 576px) {
    font-size: 18px;
    line-height: 32px;
    p, ul li {
      line-height: 32px;
      font-size: 18px;
    }
    li::marker {
      font-size: 5px;
    }
  }
}
</style>

